import React, { useMemo, useParams, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { mkConfig, generateCsv, download } from "export-to-csv";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Card } from "@mui/material";
import TableMaestros from "verticales/TableMaestros.tsx";
import fetchData from "verticales/FetchData";
import UtilModal from "verticales/UtilModal";
import ViewNewEdit from "./ViewNewEdit";
import AppLoading from "verticales/AppLoading.tsx";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import {
  IconButton,
  Tooltip,
  Box,
  Stack,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "ec2-aws-start-stop";

function Dashboard() {
  // declaracion de variables de la pantalla
  const [data, setData] = useState([]);
  const [cuentaSelect, setCuentaSelect] = React.useState({});
  const [dataInstance, setDataInstance] = React.useState([]);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [openConfirmDelete, setOpenConfirmDelete] = React.useState(false);
  const [blocking, setBlocking] = React.useState(false);
  const [msgAction, setMsgAction] = React.useState(context);

  const loadList = async (cuentaSelectSid) => {
    // setMsgAction("cargando");
    const params = {
      account: cuentaSelectSid,
      action: "get",
    };
    setBlocking(true);
    const resp = await fetchData(url, context, params);
    setData(resp.rows);
    setDataInstance(resp.bodyAdd ? resp.bodyAdd.rows : []);
    setBlocking(false);
  };

  const handleClick = async (dataPage) => {
    if (dataPage.newCuentaValue) {
      setCuentaSelect(dataPage.newCuentaValue);
      await loadList(dataPage.newCuentaValue);
    }
  };
  const handleCloseConfirmDelete = () => {
    setOpenConfirmDelete(false);
  };

  /** Segmento de la ventana emergente  */
  const [rowSelect, setRowSelect] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = (row) => {
    console.log("hola com oestsas!!!!!");
    setOpenModal(true);
    setRowSelect(row);
  };
  const handleCloseModal = async (refresh) => {
    setOpenModal(false);
    if (refresh) {
      await loadList(cuentaSelect);
    }
  };
  const handleDeleteSuccess = async () => {
    await loadList(cuentaSelect);
  };
  // const handleCloseMonitor = async (refresh) => {
  //   setOpenMonitor(false);
  //   if (refresh) {
  //     await loadList(cuentaSelect);
  //   }
  // };
  // const handleOpenMonitor = (row) => {
  //   setOpenMonitor(true);
  //   setRowInstanceSelect(row);
  // };
  const handleDeleteClick = (row) => {
    setRowToDelete(row);
    setOpenConfirmDelete(true); // Mostrar diálogo de confirmación
  };
  const confirmDelete = async () => {
    await handleDelete();
    setOpenConfirmDelete(false);
  };
  const handleDelete = async () => {
    const params = {
      action: "DELETE",
      object: {
        id: rowToDelete?.original?.id ?? -1,
      },
    };
    setBlocking(true);
    setMsgAction("eliminando");
    let resp = await fetchData(url, context, params);
    setBlocking(false);
    setOpenConfirmDelete(false);
    await loadList(cuentaSelect);
  };

  const renderView = () => {
    return (
      <ViewNewEdit
        row={rowSelect}
        handleCloseModal={handleCloseModal}
        dataInstance={dataInstance}
        // handleCloseMonitor={handleCloseMonitor}
        cuentaSelect={cuentaSelect}
      />
    );
  };

  const columns = useMemo(
    () => [
      { header: "id Instance", accessorKey: "instance_id" },
      { header: "Instancia", accessorKey: "instance_name" },
      { header: "Type", accessorKey: "instance_type" },
      { header: "Hora Apagado", accessorKey: "hora_apagado" },
      { header: "Hora Encendido", accessorKey: "hora_encendido" },
      { header: "Dias", accessorKey: "dias" },
      { header: "Comentario", accessorKey: "comentario" },
      { header: "fe Creacion", accessorKey: "fecha_creacion" },
      { header: "fe actualizacion", accessorKey: "fecha_actualizacion" },
    ],
    []
  );
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox m={1}>
                  <Autocomplete
                    disablePortal
                    id="cuentas-stop-start"
                    options={cuentasResize.map((option) => option.title)}
                    renderInput={(params) => <TextField {...params} label="Cuentas-Stop-Start" />}
                    onInputChange={(event, newCuentaValue) => {
                      handleClick({ newCuentaValue });
                    }}
                  />
                </MDBox>
              </Grid>
              {blocking ? (
                <AppLoading titleCustom={"Ec2-Aws_Start-Stop"} />
              ) : (
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox m={1}>
                    <TableMaestros
                      arrayColumns={columns}
                      data={data}
                      handleOpenModal={handleOpenModal}
                      handleDelete={handleDeleteClick}
                      handleDeleteSuccess={handleDeleteSuccess}
                      height={320}
                    />
                  </MDBox>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <UtilModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        renderView={renderView}
      />
      {/* Diálogo de Confirmación de Eliminación */}
      <Dialog open={openConfirmDelete} onClose={handleCloseConfirmDelete}>
        <DialogTitle>Confirmar Eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`¿Está seguro de que desea eliminar la instancia: ${rowToDelete?.original?.instance_id}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDelete}>No</Button>
          <Button onClick={confirmDelete} color="primary">
            Sí
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Dashboard;

const cuentasResize = [
  { title: "pdn" },
  { title: "pdn-m1" },
  { title: "pdn-m2" },
  { title: "pdn-m3" },
  { title: "pdn-m4" },
  { title: "pdn-m5" },
  { title: "pdn-m6" },
  { title: "gcp-m7" },
  { title: "zeus" },
  { title: "staging" },
  { title: "pdn-connekta" },
];
